import script from "./CompanyRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyRegister.vue?vue&type=script&setup=true&lang=js"

import "./CompanyRegister.vue?vue&type=style&index=0&id=586de08b&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586de08b"]])

export default __exports__